import React from 'react'
import PropTypes from 'prop-types'
import { View } from '@olxbr/design-system'

import ErrorMsg from '../../atoms/ErrorMsg'
import Link from '../../atoms/Link'
import styled from 'styled-components'

const Content = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const Callout = styled(Link)`
  margin-left: 6px;
`

const errorMsgCallout = props => (
  <Content>
    <ErrorMsg>{props.text}</ErrorMsg>
    <Callout type="primary" underline href={props.href} onClick={props.onClick}>
      {props.linkText}
    </Callout>
  </Content>
)

errorMsgCallout.propTypes = {
  text: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
}

export default errorMsgCallout
